import PropTypes from "prop-types";

import { Button } from "@transfr-inc/dashboard-components/forms";

import { JOURNEY_MAP_VIEW_ERRORED } from "@context/journey.context";
import { useAuth } from "@hooks/use-auth";
import { useJourney } from "@pages/journey-map/hooks/use-journey";
import { ErrorPage } from "@pages/shared";

/**
 * Fallback for the 3D journey ErrorBoundary (JourneyMapPage). Do not call
 * `resetErrorBoundary` from the primary action: that can remount 3D before the
 * parent re-renders and hit the same crash. `setJourneyMapView("errored")`
 * switches JourneyContext to the shortcut-list branch and unmounts 3D entirely.
 */
export const JourneyMapError = () => {
  const { logout } = useAuth();
  const { setJourneyMapView } = useJourney();

  const viewShortcutList = () => {
    setJourneyMapView(JOURNEY_MAP_VIEW_ERRORED);
  };

  return (
    <ErrorPage>
      <div className="error-page-message">
        <h2>Loading Error</h2>
        <p>
          Sorry, we&apos;re having trouble loading your journey map. This can
          happen when 3D isn&apos;t supported on your device or browser. In the
          meantime, you can still navigate Trek using the shortcut list.
        </p>
      </div>
      <div className="error-page-actions">
        <Button primary onClick={viewShortcutList}>
          View Shortcut List
        </Button>
        <Button onClick={() => logout()}>Sign Out</Button>
      </div>
    </ErrorPage>
  );
};

JourneyMapError.propTypes = {
  resetErrorBoundary: PropTypes.func,
};
